/* Glimmer */

/* Glimmer shell - tile styling */

.glimmerShell {
  background: var(--pm-surface) !important;
  border-radius: 6px !important;
  border: none !important;
  outline: none !important;
  /* user-select: none !important; */
  /* pointer-events: none !important; */

  &:not(theme-dark1) {
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.13) !important;
  }
}

:global(.dark) .glimmerShell,
:global(.theme-dark1) .glimmerShell {
  background: #2a3238 !important;
}
:global(.dark) :global(.mdc-dialog__surface) .glimmerShell,
:global(.theme-dark1) :global(.mdc-dialog__surface) .glimmerShell {
  background: #2b3238 !important;
}

/* Glimmer element - smaller opacity animating elements */
.glimmerElement {
  pointer-events: none;
  user-select: none;
  position: relative;
  color: transparent !important;
  border: none !important;
  outline: none !important;
  border-radius: 6px !important;
  overflow: hidden;
  background-color: #f6f7f8 !important;
  background-image: linear-gradient(
    90deg,
    rgba(21, 25, 28, 0.05) 0%,
    rgb(241, 245, 249) 20%,
    rgba(21, 25, 28, 0.05) 30%,
    rgba(21, 25, 28, 0.05) 40%
  ) !important;
  background-size: 200% !important; /* Add this line */
  animation: loadingGlimmer 1.6s linear infinite forwards !important;
}
:global(.dark) .glimmerElement,
:global(.theme-dark1) .glimmerElement {
  background-color: rgba(211, 235, 255, 0.04) !important;
  background-image: linear-gradient(
    90deg,
    rgba(168, 206, 255, 0.03) 0%,
    rgba(168, 206, 255, 0.1) 20%,
    rgba(168, 206, 255, 0.03) 40%
  ) !important;
}

@keyframes loadingGlimmer {
  0% {
    background-position: 100% 0;
  }
  50% {
    background-position: -100% 0;
  }
  50.1%,
  100% {
    background-position: -100% 0;
  }
}

.glimmerElement > *,
.glimmerElement > * > * {
  color: transparent !important;
  opacity: 0;
}

.glimmerNoBackground,
.glimmerNoBackground::before,
.glimmerNoBackground::after {
  background: none !important;
  pointer-events: none;
}

/* Item specific */

/* Headings and paragraphs */
h1.glimmerElement {
  height: 31px;
  width: 50%;
}
h2.glimmerElement {
  height: 24px;
  width: 50%;
}
h4.glimmerElement {
  height: 13px;
  width: 50%;
}
p.glimmerElement,
.glimmerParagraph {
  height: 20px;
  width: 80%;
}
.glimmerSpan {
  height: 17px;
  width: 30%;
}

/* Buttons */
button.glimmerElement {
  width: 100% !important;
  height: 46px !important;
}
button.glimmerButtonSmall,
button.glimmerElement.glimmerButtonSmall {
  width: 70px !important;
  height: 36px !important;
}

/* Labels */
span.label.glimmerElement,
label.glimmerElement {
  height: 13px;
  width: 30%;
  display: inline-block;
}
.mdc-radio + label.glimmerElement {
  width: 100px;
}

/* Titles */
span.title.glimmerElement {
  height: 17px;
  width: 30%;
}
span.title.tiny.glimmerElement {
  width: 50px;
}
span.title.short.glimmerElement {
  width: 160px;
}
span.title.long.glimmerElement {
  width: 75%;
}

/* Accordions */
.accordion.glimmerElement {
  height: 65px;
}

/* Values */
span.value.glimmerElement {
  height: 18px;
  width: 60%;
}

/* form elements */
.pmSelect.glimmerElement,
.textField.glimmerElement {
  height: 54px;
  width: 100%;
}
.textarea.glimmerElement {
  height: 86px;
  width: 100%;
}
.radio.glimmerElement {
  width: 20px;
  height: 20px;
  border-radius: 20px !important;
  margin-right: 6px;
}

/* header */
.mainHeader li .glimmerElement {
  width: 100px;
  height: 24px;
}

/* Accordions */
.glimmerElement .accordion-head {
  width: 100%;
  height: 65px;
}

/* content box */
.contentBox.glimmerElement {
  height: 130px;
}

/* scanned documents */
.attachmentElementGlimmer {
  height: 212px;
}

.gridsizeIcon {
  width: 22px;
  height: 22px;
  margin-left: 1.0625rem;
}
